import { render, staticRenderFns } from "./WidgetAddOnReviewsSummary.vue?vue&type=template&id=6ef94a06"
import script from "./WidgetAddOnReviewsSummary.vue?vue&type=script&lang=js"
export * from "./WidgetAddOnReviewsSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports